import axios from 'axios';

export const getData = async () => {
  try {
    const res = await axios({
      method: 'GET',
      url: 'https://moonquake-backend.onrender.com/get',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    return res;
  } catch (e) {}
};
